import layout from '@/layout'

export default {
  path: '/winner',
  component: layout,
  redirect: '/winner/flow_calendar',
  name: 'winner_flow_calendar',
  meta: {
    title: 'winner',
    icon: 'winner'
  },
  children: [
    {
      path: '/winner/flow_calendar',
      name: 'winner_flow_calendar',
      component: () => import('@/views/winner/pages/winner_flow_calendar/index.vue'),
      meta: {
        title: 'winner_flow_calendar',
        icon: 'calendar'
      }
    }
  ]
}
